import { render, staticRenderFns } from "./AbkOfferInvitationsList.vue?vue&type=template&id=53de2600&scoped=true&"
import script from "./AbkOfferInvitationsList.vue?vue&type=script&lang=js&"
export * from "./AbkOfferInvitationsList.vue?vue&type=script&lang=js&"
import style0 from "./AbkOfferInvitationsList.vue?vue&type=style&index=0&id=53de2600&scoped=true&lang=scss&"
import style1 from "./AbkOfferInvitationsList.vue?vue&type=style&index=1&id=53de2600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de2600",
  null
  
)

export default component.exports